import env from '../config/env';
import { postBodyMdsService } from "./oauth.service";
import config from "../config/application";

//url
const list = 'find_by_user';


class SocietyService {
    getSocieties(user) {
        let json={
            userId:user,
            systemCode:env.app.systemCode
        };
        const url = `${config.data.configuration.society.url}${list}${env.mds.query}`;
        return postBodyMdsService(url,json);
    }
    
   
}
export default new SocietyService(); 